import { render } from "./TabsView.vue?vue&type=template&id=3d75fd3a"
import script from "./TabsView.vue?vue&type=script&lang=js"
export * from "./TabsView.vue?vue&type=script&lang=js"
script.render = render

export default script